// Mock Projects Data for Modern Arch (Modern Group Nagpur)
export const projects = [
  {
    id: "modern-arch-heights",
    name: "Modern Arch Heights",
    location: "Dharampeth, Nagpur",
    city: "Nagpur",
    area: "Dharampeth",
    category: "Residential",
    type: "Apartment",
    status: "Ongoing",
    priceRange: "₹75 Lakhs - ₹1.2 Crore",
    description: "Modern Arch Heights is a premium residential project offering 2, 3, and 4 BHK luxury apartments in the heart of Dharampeth. With world-class amenities and contemporary architecture, this project redefines urban living in Nagpur.",
    amenities: ["Swimming Pool", "Gym", "Clubhouse", "24/7 Security", "Power Backup", "Landscaped Gardens", "Children's Play Area", "Covered Parking"],
    configurations: ["2 BHK - 1200 sq.ft", "3 BHK - 1650 sq.ft", "4 BHK - 2100 sq.ft"],
    totalUnits: 120,
    floors: 18,
    completionDate: "December 2025",
    reraNumber: "P52100045678",
    images: [
      "https://images.unsplash.com/photo-1617788587804-10346bac2ac3?w=800&q=80",
      "https://images.unsplash.com/photo-1757262798620-c2cc40cfb440?w=800&q=80",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80"
    ],
    floorPlans: [
      "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80"
    ],
    featured: true,
    highlights: ["Premium Location", "Smart Home Features", "Vastu Compliant"]
  },
  {
    id: "modern-embassy-towers",
    name: "Modern Embassy Towers",
    location: "Civil Lines, Nagpur",
    city: "Nagpur",
    area: "Civil Lines",
    category: "Commercial",
    type: "Commercial",
    status: "Completed",
    priceRange: "₹45 Lakhs - ₹2.5 Crore",
    description: "Modern Embassy Towers is a state-of-the-art commercial complex featuring premium office spaces, retail outlets, and a modern food court. Located in the prestigious Civil Lines area, it offers unmatched connectivity and visibility.",
    amenities: ["Central AC", "High-Speed Elevators", "Multi-level Parking", "24/7 Security", "Fire Safety Systems", "Conference Rooms", "Cafeteria", "ATM"],
    configurations: ["Office Space - 500-5000 sq.ft", "Retail Shops - 300-2000 sq.ft"],
    totalUnits: 85,
    floors: 12,
    completionDate: "March 2024",
    reraNumber: "P52100034567",
    images: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80"
    ],
    floorPlans: [
      "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80"
    ],
    featured: true,
    highlights: ["Prime Business Hub", "Metro Connectivity", "Green Building Certified"]
  },
  {
    id: "modern-villa-enclave",
    name: "Modern Villa Enclave",
    location: "Manish Nagar, Nagpur",
    city: "Nagpur",
    area: "Manish Nagar",
    category: "Residential",
    type: "Villa",
    status: "Upcoming",
    priceRange: "₹1.5 Crore - ₹3 Crore",
    description: "Experience the epitome of luxury living at Modern Villa Enclave. These exclusive 4 & 5 BHK villas offer private gardens, premium finishes, and a gated community lifestyle in the serene surroundings of Manish Nagar.",
    amenities: ["Private Garden", "Swimming Pool", "Clubhouse", "Tennis Court", "Jogging Track", "24/7 Security", "EV Charging", "Smart Home Automation"],
    configurations: ["4 BHK Villa - 3200 sq.ft", "5 BHK Villa - 4500 sq.ft"],
    totalUnits: 48,
    floors: 3,
    completionDate: "June 2027",
    reraNumber: "Coming Soon",
    images: [
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80"
    ],
    floorPlans: [
      "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80"
    ],
    featured: true,
    highlights: ["Gated Community", "Premium Villas", "Pre-Launch Offers"]
  },
  {
    id: "modern-skyline-residency",
    name: "Modern Skyline Residency",
    location: "Sadar, Nagpur",
    city: "Nagpur",
    area: "Sadar",
    category: "Residential",
    type: "Apartment",
    status: "Completed",
    priceRange: "₹55 Lakhs - ₹95 Lakhs",
    description: "Modern Skyline Residency is a successfully completed project offering comfortable 2 & 3 BHK apartments in Sadar. With excellent connectivity and modern amenities, it's the perfect home for families.",
    amenities: ["Gym", "Children's Play Area", "Covered Parking", "24/7 Security", "Power Backup", "Rainwater Harvesting", "Community Hall"],
    configurations: ["2 BHK - 980 sq.ft", "3 BHK - 1350 sq.ft"],
    totalUnits: 96,
    floors: 14,
    completionDate: "January 2023",
    reraNumber: "P52100023456",
    images: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80",
      "https://images.unsplash.com/photo-1757262798677-ab4af4455a58?w=800&q=80",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80"
    ],
    floorPlans: [
      "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80"
    ],
    featured: false,
    highlights: ["Ready to Move", "Prime Location", "Family-Friendly"]
  },
  {
    id: "modern-business-park",
    name: "Modern Business Park",
    location: "MIHAN, Nagpur",
    city: "Nagpur",
    area: "MIHAN",
    category: "Commercial",
    type: "Commercial",
    status: "Ongoing",
    priceRange: "₹35 Lakhs - ₹1.8 Crore",
    description: "Modern Business Park is a cutting-edge commercial development in MIHAN SEZ. Designed for IT companies, startups, and corporate offices, it offers world-class infrastructure and excellent connectivity to the airport.",
    amenities: ["Central AC", "Fiber Optic Connectivity", "Multi-level Parking", "Food Court", "Conference Center", "24/7 Power Backup", "Green Spaces", "Helipad"],
    configurations: ["Office Suites - 800-10000 sq.ft", "Co-working Spaces Available"],
    totalUnits: 150,
    floors: 20,
    completionDate: "September 2026",
    reraNumber: "P52100056789",
    images: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80"
    ],
    floorPlans: [
      "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80"
    ],
    featured: true,
    highlights: ["SEZ Location", "IT-Ready Infrastructure", "Airport Proximity"]
  }
];

export const locations = ["All Locations", "Dharampeth", "Civil Lines", "Manish Nagar", "Sadar", "MIHAN"];
export const categories = ["All Categories", "Residential", "Commercial"];
export const types = ["All Types", "Apartment", "Villa", "Commercial"];
export const statuses = ["All Status", "Ongoing", "Completed", "Upcoming"];
export const budgets = ["All Budgets", "Under ₹50 Lakhs", "₹50 Lakhs - ₹1 Crore", "₹1 Crore - ₹2 Crore", "Above ₹2 Crore"];
